import * as http from '../../modules/http';
import * as UrlParamsManager from '../../modules/UrlParamsManager';


export const ADMIN_REQUEST_START = 'ADMIN_REQUEST_START';
export const ADMIN_REQUEST_SUCCESS = 'ADMIN_REQUEST_SUCCESS';
export const ADMIN_REQUEST_FAILED = 'ADMIN_REQUEST_FAILED';
export const ADMIN_REQUEST_NO_PERMISSION = 'ADMIN_REQUEST_NO_PERMISSION';
export const ADMIN_UPDATE_FIELD = 'ADMIN_UPDATE_FIELD';
export const ADMIN_OPEN_STORE_UPDATE_FORM = 'ADMIN_OPEN_STORE_UPDATE_FORM';
export const ADMIN_STORE_INSERT = 'ADMIN_STORE_INSERT';
export const ADMIN_STORE_UPDATE = 'ADMIN_STORE_UPDATE';
export const ADMIN_STORE_DELETE = 'ADMIN_STORE_DELETE';
export const ADMIN_OPEN_MANAGER_UPDATE_FORM = 'ADMIN_OPEN_MANAGER_UPDATE_FORM';
export const ADMIN_MANAGER_INSERT = 'ADMIN_MANAGER_INSERT';
export const ADMIN_MANAGER_UPDATE = 'ADMIN_MANAGER_UPDATE';
export const ADMIN_MANAGER_DELETE = 'ADMIN_MANAGER_DELETE';
export const ADMIN_OPEN_HNAME_UPDATE_FORM = 'ADMIN_OPEN_HNAME_UPDATE_FORM';
export const ADMIN_HNAME_INSERT = 'ADMIN_HNAME_INSERT';
export const ADMIN_HNAME_UPDATE = 'ADMIN_HNAME_UPDATE';
export const ADMIN_HNAME_DELETE = 'ADMIN_HNAME_DELETE';

export const ADMIN_OPEN_SGROUP_UPDATE_FORM = 'ADMIN_OPEN_SGROUP_UPDATE_FORM';
export const ADMIN_SGROUP_INSERT = 'ADMIN_SGROUP_INSERT';
export const ADMIN_SGROUP_UPDATE = 'ADMIN_SGROUP_UPDATE';
export const ADMIN_SGROUP_DELETE = 'ADMIN_SGROUP_DELETE';

export const ROUTES_OPEN_FORM = 'ROUTES_OPEN_FORM';

export function admin_request_start(country,date,product,platform) {
    return {
        type: ADMIN_REQUEST_START,
        country:country,
        date:date,
        product:product,
        platform:platform
    };
}

export function admin_request_success(data) {
    return {
        type: ADMIN_REQUEST_SUCCESS,
        stores:data.stores,
        managers:data.managers,
        handleName:data.handleName,
        storeGroup:data.storeGroup
    };
}

export function admin_request_failed() {
    return {
        type: ADMIN_REQUEST_FAILED
    };
}

export function admin_request_no_permission() {
    return {
        type: ADMIN_REQUEST_NO_PERMISSION
    };
}

export function admin_update_field(storeOrManager,field,value) {
    return {
        type: ADMIN_UPDATE_FIELD,
        storeOrManager: storeOrManager,
        field: field,
        value: value
    };
}

export function admin_open_store_update_form(store) {
    return {
        type: ADMIN_OPEN_STORE_UPDATE_FORM,
        store:store
    };
}

export function admin_store_insert(data) {
    return {
        type: ADMIN_STORE_INSERT,
        data: data
    };
}

export function admin_store_update(data) {
    return {
        type: ADMIN_STORE_UPDATE,
        data: data
    };
}

export function admin_store_delete(id) {
    return {
        type: ADMIN_STORE_DELETE,
        id: id
    };
}

export function admin_open_manager_update_form(manager) {
    return {
        type: ADMIN_OPEN_MANAGER_UPDATE_FORM,
        manager:manager
    };
}

export function admin_manager_insert(data) {
    return {
        type: ADMIN_MANAGER_INSERT,
        data: data
    };
}

export function admin_manager_update(data) {
    return {
        type: ADMIN_MANAGER_UPDATE,
        data: data
    };
}

export function admin_manager_delete(id) {
    return {
        type: ADMIN_MANAGER_DELETE,
        id: id
    };
}

export function admin_open_hname_update_form(hname) {
    return {
        type: ADMIN_OPEN_HNAME_UPDATE_FORM,
        hname:hname
    };
}

export function admin_hname_insert(data) {
    return {
        type: ADMIN_HNAME_INSERT,
        data: data
    };
}

export function admin_hname_update(data) {
    return {
        type: ADMIN_HNAME_UPDATE,
        data: data
    };
}

export function admin_hname_delete(id) {
    return {
        type: ADMIN_HNAME_DELETE,
        id:id
    };
}

export function admin_open_sgroup_update_form(sgroup) {
    return {
        type: ADMIN_OPEN_SGROUP_UPDATE_FORM,
        sgroup:sgroup
    };
}

export function admin_sgroup_insert(data) {
    return {
        type: ADMIN_SGROUP_INSERT,
        data: data
    };
}

export function admin_sgroup_update(data) {
    return {
        type: ADMIN_SGROUP_UPDATE,
        data: data
    };
}

export function admin_sgroup_delete(id) {
    return {
        type: ADMIN_SGROUP_DELETE,
        id:id
    };
}

export function routes_open_form(id) {
    return {
        type: ROUTES_OPEN_FORM,
        id:id
    };
}
//
//
//Async Actions
//
//

export function fetchAdminDataIfNeeded(queryParams) {
    var country = UrlParamsManager.getCountry(queryParams);
    var date = UrlParamsManager.getDate(queryParams);
    var product = UrlParamsManager.getProduct(queryParams);
    var platform = UrlParamsManager.getPlatform(queryParams);
    var accountID = UrlParamsManager.getAccount(queryParams);

    return (dispatch, getState) => {
        if (shouldFetchAdminData(getState(),country,date,product,platform, accountID)) {
            return dispatch(fetchAdminData(country,date,product,platform, accountID));
        }
    };
}

function shouldFetchAdminData(state,country,product,date,platform, accountID) {
    if (!state.admin.data){
        return true;
    }
    else{
        return false;
    }
}


function fetchAdminData(country,date,product,platform, accountID) {

    var dateFilter = {
        filter:true,
        platform:platform,
        value:date.date,
        range:{startDate:date.startDate,endDate:date.endDate}
    };

    var requestParams = {date:dateFilter, country:country,product:product,platform:platform, accountID: parseInt(accountID)};

    return ((dispatch) => {
        dispatch(admin_request_start(country,date,product,platform));

        let request = 'admin/get';

        http.postToServer(request,
            requestParams,
            (response) =>  {dispatch(admin_request_success(response.data))},
            (response) =>  {dispatch(admin_request_failed())},
            (response) =>  {dispatch(admin_request_no_permission())}

        );

    });
}